import { useAtomValue } from 'jotai'
import React from 'react'

import { buildFiveSegmentsCustomerAttributesArrayData } from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { type Brand } from '~/hooks/useSurveyQuery'

import { fiveSegmentSortFunctionAtom } from '../atoms'

import { useGetFiveSegmentsData } from './useGetFiveSegmentsData'
import { useNineSegmentsCustomerAttributesArrayData } from './useNineSegmentsCustomerAttributesArrayData'

export const useFiveSegmentsCustomerAttributesArrayData = (brand: Brand) => {
  const nineSegmentsCustomerAttributesArrayData =
    useNineSegmentsCustomerAttributesArrayData(brand)

  const getFiveSegmentsData = useGetFiveSegmentsData(brand)
  const sort = useAtomValue(fiveSegmentSortFunctionAtom)

  return React.useMemo(
    () =>
      buildFiveSegmentsCustomerAttributesArrayData({
        getFiveSegmentsData,
        nineSegmentsCustomerAttributesArrayData,
        sort,
      }),
    [getFiveSegmentsData, nineSegmentsCustomerAttributesArrayData, sort],
  )
}
